import React from 'react'
import { toast } from 'react-toastify'
import _ from 'lodash'

import { fetchPortalHostByFields } from '../../../modules/portal-remote/portalService'
import CopyToClipboard from '../../views/widgets/CopyToClipboard'
import QRCodeButton from '../qrcode/QRCodeButton'
import styled from 'styled-components'

//with hooks
export default function PortalDynamicLink({ hostRef, language = 'th' }) {
  const [portals, setPortals] = React.useState([])
  const [isActive, setIsActive] = React.useState(false)

  React.useEffect(() => {
    fetchPortalHostByFields(hostRef, 'town,dynamicLink,mainImageId')
      .then(portals => {
        setPortals(portals)
      })
      .catch(error => {
        toast.error(error.message)
      })
  }, [hostRef])

  function toggleLink() {
    setIsActive(!isActive)
  }

  // if (_.isEmpty(portals)) {
  //   return null
  // }

  return (
    <div>
      <button
        className={`button is-small is-pulled-left ${isActive && 'is-active '}`}
        onClick={toggleLink}
      >
        LINK/QR-CODE
      </button>
      {isActive && (
        <div>
          <br />
          <br />
          <LinkBodyLayout className="box ">
            {portals.map(
              portal =>
                !_.isEmpty(portal.dynamicLink) && (
                  <div className="columns is-gapless">
                    <div className="column is-4">
                      <div className="tags has-addons">
                        <span className="tag notes">
                          <small>TOWN</small>
                        </span>
                        <span className="tag is-primary">
                          {_.get(portal, `town.title.${language}`)}
                        </span>
                      </div>
                    </div>
                    <div className="column">
                      <CopyToClipboard text={portal.dynamicLink}>
                        <QRCodeButton
                          title="QR CODE PORTAL"
                          text={portal.dynamicLink}
                          imageID={portal.mainImageId}
                        />
                      </CopyToClipboard>
                    </div>
                  </div>
                ),
            )}
          </LinkBodyLayout>
        </div>
      )}
    </div>
  )
}

const LinkBodyLayout = styled.div`
  position: absolute;
  width: 480px;
  z-index: 10;
`



// WEBPACK FOOTER //
// ./src/components/templates/portal-dynamic-link/PortalDynamicLink.js